import React from 'react';
import PropTypes from 'prop-types';
import { CONTACTS } from '@department-of-veterans-affairs/component-library/contacts';

export const errorTypes = Object.freeze({
  NOT_FOUND: 'not found',
  DOWNLOAD_ERROR: 'download error',
  SYSTEM_ERROR: 'system error',
});

export const phoneComponent = number => {
  return (
    <>
      <va-telephone contact={number} /> (
      <va-telephone contact={CONTACTS['711']} tty />)
    </>
  );
};

export const NotFoundComponent = () => {
  return (
    <va-alert close-btn-aria-label="Close notification" status="info" visible>
      <h3 slot="headline" className="vads-u-font-size--h4">
        You don’t have any 1095-B tax forms available right now
      </h3>
      <p className="vads-u-margin-y--0">
        You do not have any 1095-B tax forms available. This could be because
        you were a CHAMPVA beneficiary or you weren’t enrolled in VA healthcare
        in the last three years. If you think you were enrolled, call us at{' '}
        {phoneComponent(CONTACTS['222_VETS'])}. We’re here Monday through
        Friday, 8:00 a.m. to 8:00 p.m. ET.
      </p>
    </va-alert>
  );
};

export const downloadErrorComponent = (
  <div
    id="downloadError"
    data-testid="downloadError"
    className="vads-u-margin-bottom--2p5"
  >
    <va-alert close-btn-aria-label="Close notification" status="error" visible>
      <p className="vads-u-margin-y--0">
        We’re sorry. Something went wrong when we tried to download your form.
        Please try again. If your form still doesn’t download, call us at{' '}
        {phoneComponent(CONTACTS['222_VETS'])}. We’re here 24/7.
      </p>
    </va-alert>
  </div>
);

export const systemErrorComponent = (
  <va-alert close-btn-aria-label="Close notification" status="error" visible>
    <h3 slot="headline" className="vads-u-font-size--h4">
      System error
    </h3>
    <p className="vads-u-margin-y--0">
      We’re sorry, something went wrong on our end. Try to view your 1095-B
      later. If the issue persists, call us at{' '}
      {phoneComponent(CONTACTS['222_VETS'])}. We’re here 24/7.
    </p>
  </va-alert>
);

export const PendingFormAlert = ({ taxYear }) => (
  <va-alert
    status="info"
    visible
    slim
    data-testid={`pending-form-alert-${taxYear}`}
  >
    <p className="vads-u-margin--0">
      Your {taxYear} form is not yet available. It will be ready for download in
      January {taxYear + 1}.
    </p>
  </va-alert>
);

PendingFormAlert.propTypes = {
  taxYear: PropTypes.number.isRequired,
};

export const PdfHelp = () => {
  return (
    <div className="vads-u-margin-top--4">
      <p>
        If you’re having trouble accessing your 1095-B, you may need the latest
        version of Adobe Acrobat Reader. It’s free to download.{' '}
        <va-link
          href="https://get.adobe.com/reader"
          text="Get Acrobat Reader for free from Adobe."
        />
      </p>
      <p>
        If you’re still having trouble accessing your 1095-B, call our MyVA411
        main information line at {phoneComponent(CONTACTS.VA_411)}.
      </p>
      <p>
        If this page is missing a 1095-B for a year you were enrolled in VA
        health care within the past 3 years, call us at{' '}
        {phoneComponent(CONTACTS['222_VETS'])}. We’re here Monday through
        Friday, 8:00 a.m. to 8:00 p.m. ET.
      </p>
    </div>
  );
};
